import { useEffect, useState, forwardRef } from "react";
import "./TeamMembers.scss";
import { motion } from "framer-motion";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const TeamMembers = forwardRef((props, ref) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch team members directly here
  const getTeamMembers = async () => {
    try {
      const response = await axios.get(`${API_URL}/team`);
      return response.data;
    } catch (error) {
      console.error("Error fetching team members:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchTeam = async () => {
      setLoading(true);
      const data = await getTeamMembers();
      setTeamMembers(data);
      setLoading(false);
    };

    fetchTeam();
  }, []);

  return (
    <section className="teamMember-section">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h2>The minds behind the mission</h2>
      </motion.div>

      <div className="team-grid" ref={ref}>
        {loading ? (
          <div className="spinnerContainer">
            <div className="spinner"></div>
            <div className="loader">
              <p>Loading</p>
              <div className="words">
                <span className="word">requests</span>
                <span className="word">cookies</span>
                <span className="word">headers</span>
                <span className="word">caching</span>
                <span className="word">sessions</span>
              </div>
            </div>
          </div>
        ) : (
          teamMembers.map((member, index) => (
            <div className="team-card" key={member.id || index}>
              <motion.div
                className="card-inner"
                initial={{ opacity: 0, y: 0, filter: "blur(10px)" }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                  filter: "blur(0px)",
                  transition: { duration: 0.6, delay: index * 0.3 },
                }}
                viewport={{ once: true }}
              >
                <div className="image-container">
                  <img
                    src={`${API_URL}/team/${member.id}/image`}
                    alt={member.fullname}
                  />
                </div>
                <div className="team-info">
                  <h3>{member.fullname}</h3>
                  <p className="role">{member.designation}</p>
                  {member.bio && <p className="bio">{member.bio}</p>}
                </div>
              </motion.div>
            </div>
          ))
        )}
      </div>
    </section>
  );
});

export default TeamMembers;
